import { Badge } from '@indipia/ui-core'
import { shipPhaseChips, type ShipDeliveryList } from '../../constants/ship.logic'
import { SHIP_POPUP_TEXT } from '../../constants/ship.logic'

/** C-4 요약 4칸 — 서버 summary 값 그대로, 클릭 동작 없음. 숫자는 글자로 함께 표시(색만으로 구분하지 않음). */
export function ShipSummaryChips({ summary }: { summary: ShipDeliveryList['summary'] }) {
  const chips = shipPhaseChips(summary)
  return (
    <div role="group" aria-label={SHIP_POPUP_TEXT.summaryLabel} style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {chips.map(c => (
        <Badge key={c.phase} variant="soft" status={c.badge}>
          {c.label} {c.count}
        </Badge>
      ))}
    </div>
  )
}
